import styled from 'styled-components';
export const CollapseContainer = styled.div `
  display: flex;
  flex-direction: column;
`;
export const CollapsePanelHeader = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: ${({ $expandIconPosition }) => $expandIconPosition === 'start'
    ? 'row-reverse'
    : $expandIconPosition === 'bottom'
        ? 'column'
        : $expandIconPosition === 'top'
            ? 'column-reverse'
            : 'row'};

  ${({ $headerIsColumnOnTablet, theme, $expandIconPosition }) => {
    var _a;
    return $headerIsColumnOnTablet
        ? `
          @media (max-width: ${(_a = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _a === void 0 ? void 0 : _a.tablet}px) {
            flex-direction: ${['start', 'top'].includes($expandIconPosition)
            ? 'column-reverse'
            : 'column'};
          }
          `
        : undefined;
}}

  gap: ${({ theme }) => theme.spacing.md}px;
  cursor: pointer;
`;
export const CollapsePanelTitle = styled.div `
  width: 100%;
  flex: 1 1 auto;
  min-width: 0;
`;
export const CollapsePanelHeaderActions = styled.div `
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.sm}px;
  align-items: center;
  width: fit-content;
  flex-shrink: 0;
`;
export const CollapsePanelExpandButton = styled.button `
  display: flex;
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'fit-content')};
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  cursor: pointer;
`;
export const CollapsePanelExpandPositioner = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const CollapsePanelContainer = styled.div `
  ${({ $ghost, theme, $hasGap }) => !$ghost
    ? `
      border: 1px solid ${theme.colors.grey_4};
      border-radius: ${theme.border_radius.sm};
      overflow: hidden;
      box-shadow: ${theme.appearance.box_shadow};
      &:hover {
        box-shadow: ${theme.appearance.box_shadow_hover};
      }
      ${$hasGap
        ? `border-bottom: 1px solid ${theme.colors.grey_4};`
        : 'border-bottom:none;'}
      &:last-child {
        border-bottom: 1px solid ${theme.colors.grey_4};
      }
      background-color: ${theme.colors.white_1};`
    : undefined}

  .ReactCollapse--collapse {
    transition: height 500ms;
  }
  .ReactCollapse--content {
    padding-inline: ${({ $noPadding, theme }) => !!$noPadding ? 0 : theme.spacing.md}px;
    padding-block: ${({ $noPadding, theme }) => !!$noPadding ? 0 : theme.spacing.sm}px;
    ${(props) => !props.$ghost
    ? `border-top: 1px solid ${props.theme.colors.grey_4};`
    : undefined}
  }

  ${CollapsePanelHeader} {
    padding-inline: ${({ $noPadding, theme }) => !!$noPadding ? 0 : theme.spacing.md}px;
    padding-block: ${({ $noPadding, theme }) => !!$noPadding ? 0 : theme.spacing.sm}px;

    ${(props) => !props.$ghost
    ? `
      background-color: ${props.theme.colors.white_1};
      `
    : undefined}
  }
`;
export const CollapsePanelBody = styled.div ``;
